import { defineStore } from 'pinia'
import { TableHeader } from '@/store/models/table'
import { defaultLineItemHeaders, defaultWorkOrderHeaders } from '@/store/helpers/default-values'
import { can } from '@layouts/plugins/casl'
import type { TableOptions } from '@/models/general/table'

export const useBrandingStore = defineStore({
  id: 'branding',
  persist: true,

  state: () => ({
    workOrderHeaders: defaultWorkOrderHeaders as TableHeader[],
    lineItemHeaders: defaultLineItemHeaders as TableHeader[],
    globalFilters: {
      projectFilter: [] as any[],
      supplierFilter: [] as any[],
      eventGroupFilter: [] as any[],
      category1Filter: [] as any[],
      category2Filter: [] as any[],
      responsibleFilter: [] as any[],
      assignedToFilter: [] as any[],
      statusFilter: [] as any[],
      zoneFilter: [] as any[],
      areaFilter: [] as any[],
      priorityFilter: [] as any[],
    },
    lineItemTableOptions: {
      itemsPerPage: 20,
      page: 1,
      sortBy: []
    } as TableOptions
  }),

  getters: {
    filteredWorkOrderHeaders: state => {
      if (can('view', 'finances')) {
        return state.workOrderHeaders
      }
      return state.workOrderHeaders.filter(item => !['budget'].includes(item.key))
    },
    filteredDefaultWorkOrderHeaders: state => {
      if (can('view', 'finances')) {
        return defaultWorkOrderHeaders
      }
      return defaultWorkOrderHeaders.filter(item => !['budget'].includes(item.key))
    },
    filteredLineItemGlobalHeaders: state => {
      if (can('view', 'finances')) {
        return state.lineItemHeaders
      }
      return state.lineItemHeaders.filter(item => !['price', 'total'].includes(item.key))
    },
    filteredDefaultLineItemGlobalHeaders: state => {
      if (can('view', 'finances')) {
        return defaultLineItemHeaders
      }
      return defaultLineItemHeaders.filter(item => !['price', 'total'].includes(item.key))
    },
  },

  actions: {
    updateWorkOrderHeaders(headers: TableHeader[]) {
      this.workOrderHeaders = headers
    },

    updateLineItemHeaders(headers: TableHeader[]) {
      this.lineItemHeaders = headers
    },
  },
})

// Define the type of the store
export type BrandingStore = ReturnType<typeof useBrandingStore>
